import type { ApiClientConfig, TokenProvider } from '@hetivo/hetivo-lib-types';
import { createApiLogger } from '@hetivo/hetivo-lib-front-utils';
import { env } from '&/config';

/** API client configurations for the frontoffice app */
export const apiConfigs: Record<string, ApiClientConfig> = {
  'admin-auth': {
    baseURL: `${env.apiBaseUrl}/admin-auth`,
    timeout: 10_000,
  },
  geo: {
    baseURL: `${env.apiBaseUrl}/geo`,
    timeout: 10_000,
  },
};

/** Console-based logger (replace with HetivoLogger when available) */
export const apiLogger = createApiLogger(env.isDev);

/** Correlation ID prefix for frontoffice */
export const CORRELATION_ID_PREFIX = 'fo';

/**
 * Mutable token provider ref. Set by AuthApiClientBridge when auth context mounts.
 * This indirection is needed because ApiClient instances are memoized — the stable
 * tokenProvider reference delegates to the latest getToken from auth context.
 */
let _tokenProviderFn: TokenProvider = (): Promise<null> => Promise.resolve(null);

export function setTokenProvider(provider: TokenProvider): void {
  _tokenProviderFn = provider;
}

export const tokenProvider: TokenProvider = (): Promise<string | null> => _tokenProviderFn();
